import { render, staticRenderFns } from "./PersonalDetails.vue?vue&type=template&id=5dd3430f&scoped=true&"
import script from "./PersonalDetails.vue?vue&type=script&lang=js&"
export * from "./PersonalDetails.vue?vue&type=script&lang=js&"
import style0 from "./PersonalDetails.vue?vue&type=style&index=0&id=5dd3430f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd3430f",
  null
  
)

export default component.exports